import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import styled from 'styled-components';
import { API_ROOT } from 'Api/Routes';

const ShowAvatar = styled(Avatar)`
  background-color: #62727b !important;
`;
const Holder = styled.div`
  width: 40px;
  height: 40px;
`;

const renderName = user => {
  let final = '';
  let name = '';
  let lastname = '';
  let fullname = '';
  fullname = user.split(' ');
  name = fullname[0].toUpperCase().charAt(0);
  lastname = fullname[1] && fullname[1].toUpperCase().charAt(0);
  final = name + lastname;
  return final;
};

function AvatarUser(props) {
  if (props.showAvatar) {
    return (
      <ShowAvatar className="mui-avatar" index={props.index}>
        {renderName(props.user)}
      </ShowAvatar>
    );
  } else {
    return <Holder />;
  }
}

export default AvatarUser;
